import ModalWizard from '@/pages/publicpages/agent/wizard/Index';
import GroupedErrors from "@/vue/components/GroupedErrors.vue";

Vue.component('ModalWizard', ModalWizard);
Vue.component('GroupedErrors', GroupedErrors);

new Vue({
    el: '#help-buy-rent-sell',
    name: 'HelpBuyRentSell',
    mounted() {
        setTimeout(() => {
            if (window.location.hash === '#encontrar-o-agente-certo') {
                $('#encontrar-o-agente-certo').modal('show');
            }
        }, 500);
    }
})